import React from "react";
import { motion } from "framer-motion";
import { Reveal, Overline } from "./primitives";
import { WHO_FOR } from "./content";

const EASE = [0.16, 1, 0.3, 1];

export default function WhoFor() {
  return (
    <section data-testid="who-for-section" className="relative bg-stone py-28 md:py-40">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <Reveal className="mb-16 md:mb-24 max-w-[22ch]">
          <Overline className="text-copper">Who This Is For</Overline>
          <h2 className="mt-6 font-serif text-4xl leading-[1.05] text-ink sm:text-6xl lg:text-7xl">
            Designed for the discerning few.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 gap-px overflow-hidden border border-ink/10 bg-ink/10 md:grid-cols-3">
          {WHO_FOR.map((w, i) => (
            <motion.div
              key={w.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.9, ease: EASE, delay: (i % 3) * 0.1 }}
              className="group flex flex-col justify-between gap-10 bg-warm p-10 transition-colors duration-500 hover:bg-forest md:p-12 md:min-h-[300px]"
            >
              <span className="font-serif text-5xl text-champagne">0{i + 1}</span>
              <div>
                <h3 className="font-serif text-2xl text-ink transition-colors duration-500 group-hover:text-warm md:text-3xl">
                  {w.title}
                </h3>
                <p className="mt-3 leading-relaxed text-ink/60 transition-colors duration-500 group-hover:text-warm/70">
                  {w.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
